/**
 * @file routes.ts
 * @description Application routes
 *
 * IMPORTANT
 * Those routes are used in the application to navigate between pages.
 * I does NOT represent the actual API routes.
 *
 * @see /src/constants/endpoints.ts
 */

export const AUTH = {
  SIGNIN: "/signin",
  SIGNOUT: "/signout",
  FORGOT_PASSWORD: "/forgot-password",
};

export const DASHBOARD = {
  HOME: "/home",

  // profile
  PROFILE: "/profile/uuid/update",
  PROFILE_RESET_PASSWORD: "/profile/reset-password",
  // customers
  CUSTOMERS: "/customers",
  CUSTOMERS_CREATE: "/customers/create",
  CUSTOMERS_ARCHIVED: "/customers/archived",
  CUSTOMERS_LOGS: "/customers/logs",
  CUSTOMERS_REPORTS: (id: string) => `/customers/${id}/reports`,
  CUSTOMERS_READ: (id: string) => `/customers/${id}`,
  CUSTOMERS_EDIT: (id: string) => `/customers/${id}/edit`,
  CUSTOMERS_BANK_ACCOUNT: (id: string) => `/customers/${id}/bank-account`,
  CUSTOMERS_DEATH_CERTIFICATION: (id: string) => `/customers/${id}/death-certificate`,
  CUSTOMERS_LEGATES: (id: string) => `/customers/${id}/legates`,

  //legates
  CUSTOMERS_LEGATES_CREATE: (id: string) => `/customers/${id}/legate-create`,
  CUSTOMERS_LEGATES_EDIT: (id: string) => `/customers/${id}/legate-edit`,
  CUSTOMERS_LEGATES_READ: (id: string) => `/customers/${id}/legate-view/`,
  CUSTOMERS_LEGATES_BANK_ACCOUNT: (id: string) => `/customers/${id}/legate-bank-account`,
  CUSTOMERS_LEGATES_REPORTS: (id: string) => `/customers/${id}/legate-reports`,
  CUSTOMERS_LEGATES_DEATH_CERTIFICATION: (id: string) => `/customers/${id}/legate-death-certificate`,

  // proceedings
  PROCEEDINGS: "/proceedings",
  PROCEEDINGS_READ: (id: string) => `/proceedings/${id}`,
  PROCEEDINGS_DOCUMENTS: (id: string) => `/proceedings/documents/${id}`,
  PROCEEDINGS_DOCUMENTS_CUSTOMER: (id: string) => `/proceedings/${id}?tab=info`,

  PRECATORY: "/precatory",
  PRECATORY_LIST: "/precatory-proceedings",
  PRECATORY_ARCHIVED: "/precatory-proceedings/archived",
  PRECATORY_CREATE: "/precatory-proceedings/create",
  PRECATORY_EDIT: (id: string) => `/precatory-proceedings/${id}/edit`,
  PRECATORY_READ: (id: string) => `/precatory-proceedings/${id}/`,

  PUBLICATIONS: "/publications",

  CIVIL_PROCEEDINGS: "/civil-proceedings",

  DOCUMENTS: "/documents",
  COMMON_COURT: "/documents/create/common_court",
  LABOR_COURT: "/documents/create/labor_court",

  // calendar
  CALENDAR: "/calendar",

  // reminders
  REMINDERS: "/reminders",

  // logs de chamada
  LOGSCHAMADA: (uuid: string) => `/logs-chamada/${uuid}`,

  //team
  TEAM: "/team",
  TEAM_CREATE: "/team/create",
  TEAM_ARCHIVED: "/team/archived",
  TEAM_EDIT: (id: string) => `/team/${id}/edit`,
  INFO: "/information",

  //Finance
  FINANCE: "/finance",
  FINANCE_CANCELED: "/finance/receipts-canceled",
  CREATE_RECEIPT: "/finance/create-receipt",

  //Notifications
  NOTIFICATIONS: "/notifications",
};
